module.exports = __webpack_public_path__ + "static/media/code-labs.2fc4686b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/code-labs.png
 ** module id = 351
 ** module chunks = 0
 **/